export default __webpack_public_path__ + "static/media/coding.f1efcd51.png";